import { z } from "zod";
import utcToLocal from '@/use/utcToLocal';

export const ProjectContactSchema = z.object({
    id: z.string().optional(),
    client_id: z.coerce.number().optional(),
    first_name: z.string().optional().nullable(),
    last_name: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
    company_name: z.string().optional().nullable(),
    phone_number: z.string().optional().nullable(),
    extension: z.string().optional().nullable(),
    fax_number: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
    label: z.string().optional().nullable(),
    sort_order: z.coerce.number().optional().nullable(),
    created_by: z.string().optional().nullable(),

    created_at: z.string().transform((val:string) => utcToLocal(val)).nullable(),
    last_edited_at: z.string().transform((val:string) => utcToLocal(val)).nullable(),
});

export type ProjectContactContact = z.infer<typeof ProjectContactSchema>;
